import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import cache from 'utilities/cache';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      minWidth: 300,
    },
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  content: {
    padding: theme.spacing(2),
  },
  videoTitle: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  titleText: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
}));

export default function NewVideoNotificationModal({ open, onClose, video }) {
  const classes = useStyles();
  const history = useHistory();
  const pathPrefix = cache.get('app:pathPrefix');

  const handleViewVideo = () => {
    history.push(`/${pathPrefix}/instructionVideo/${video.category}/${video.id}`);
    onClose();
  };

  return (
    video && (
      <Dialog
        open={open}
        onClose={onClose}
        className={classes.root}
      >
        <DialogTitle className={classes.title}>
          <Typography className={classes.titleText}>📣 新教學影片通知</Typography>
        </DialogTitle>
        <DialogContent className={classes.content}>
          <Typography>
            有新的教學影片「{<span className={classes.videoTitle}>{video.title}</span>}」已上傳，是否要立即觀看？
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            稍後觀看
          </Button>
          <Button onClick={handleViewVideo} color="primary" variant="contained">
            立即觀看
          </Button>
        </DialogActions>
      </Dialog>
    )
  );
}

NewVideoNotificationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  video: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  }),
};
